<template>
  <div class="absolute inset-0">
    <div
      class="mx-auto flex h-full w-1/2 flex-col items-center justify-center space-y-6"
    >
      <i v-html="$icons.error_lg" class="text-ontick-red-600"></i>
      <div class="flex flex-col space-y-2 text-center">
        <h2 class="text-2xl font-bold sm:text-4xl">
          Erro na confirmação da transação.
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Não conseguimos confirmar sua transação. Entre em contato com nosso
          suporte para mais informações.
        </p>
      </div>
      <router-link to="/" class="w-full">
        <ontick-button class="flex w-full items-center space-x-2">
          <i v-html="$icons.arrow_left"></i>
          <span>Voltar para a página inicial</span>
        </ontick-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
